"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageDataSpecStatusSchema = exports.PackageDataSpecStatus = void 0;
const z = require("zod");
var PackageDataSpecStatus;
(function (PackageDataSpecStatus) {
    PackageDataSpecStatus["Active"] = "active";
    PackageDataSpecStatus["Retired"] = "retired";
})(PackageDataSpecStatus || (exports.PackageDataSpecStatus = PackageDataSpecStatus = {}));
exports.PackageDataSpecStatusSchema = z.nativeEnum(PackageDataSpecStatus);
//# sourceMappingURL=package-data-spec-status.js.map